// extracted by mini-css-extract-plugin
export default {"button":"Login_button__O8h0T","screenCenter":"Login_screenCenter__umBRA"};